import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Link from '@material-ui/core/Link'
import Paper from '@material-ui/core/Paper'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'
import useTranslation from 'hooks/useTranslations'
import clsx from 'clsx'

const CookiesPopover = props => {
  const { open, onAccept, onReject } = props

  const [colorAlternative] = useState(
    '/kitdigital' === window.location.pathname,
  ) // Need refactor (read variable)

  const classes = useStyles()

  const t = useTranslation()

  return (
    <Paper hidden={!open} className={classes.dialog}>
      <DialogTitle
        id="customized-dialog-title"
        className={clsx(
          classes.dialogTitle,
          colorAlternative && classes.dialogTitleColorAlternative,
        )}
        disableTypography={true}
      >
        <Typography variant="h2" className={classes.titleText}>
          {t('cookies:title')}{' '}
          <span role="img" aria-label="cookies">
            🍪
          </span>
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {t('cookies:info')}{' '}
        <Link
          href={t('cookies:url-link-here')}
          target="_blank"
          rel="noopener noreferrer"
          className={clsx(
            colorAlternative && classes.dialogContentLinkColorAlternative,
          )}
        >
          {t('cookies:link-here')}
        </Link>
        .
      </DialogContent>
      <Grid container justify="flex-end" className={classes.actions}>
        <Grid item>
          <Button
            onClick={onReject}
            variant="outlined"
            color="primary"
            className={clsx(
              classes.noAceptButton,
              colorAlternative && classes.noAceptButtonColorAlternative,
            )}
          >
            {t('cookies:no-acept')}
          </Button>
        </Grid>

        <Grid item>
          <Button
            onClick={onAccept}
            variant="contained"
            color="primary"
            className={clsx(
              classes.aceptButton,
              colorAlternative && classes.aceptButtonColorAlternative,
            )}
          >
            {t('cookies:acept')}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  )
}

CookiesPopover.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
}

export default CookiesPopover
